module.exports = __webpack_public_path__ + "img/Investment.fb5ecb84.svg";